import authentication from "@irati/auth"
import {Deal} from "@irati/types"
import {isUserDOBRequired, userDOBIsWithinRedemptionWindow} from "@irati/deals/helpers/deals/redemptionEvents/dateOfBirth"

export const getDealForHomepageBanner = (taggedDeal: Deal, birthdayDeal: Deal) => {
  return birthdayDeal && isUserDOBRequired(birthdayDeal) && userDOBIsWithinRedemptionWindow(birthdayDeal, authentication.user().dob)
    ? birthdayDeal
    : taggedDeal
}
